import React, { useState, useEffect } from 'react';

const Notification = ({ message, type = 'info', closable = false, visibility = true, autoClose = 0 }) => {
    const [show, setShow] = useState(visibility);

    // Optional Auto-close logic
    useEffect(() => {
        if (autoClose > 0 && show) {
            const timer = setTimeout(() => setShow(false), autoClose);
            return () => clearTimeout(timer);
        }
    }, [autoClose, show]);

    if (!show) return null;

    // Define modern color palette
    const theme = {
        success: { bg: '#F0FDF4', border: '#16A34A', text: '#166534', icon: 'fa-check-circle' },
        danger: { bg: '#FEF2F2', border: '#DC2626', text: '#991B1B', icon: 'fa-exclamation-circle' },
        info: { bg: '#EEF2FF', border: '#4F46E5', text: '#3730A3', icon: 'fa-info-circle' },
        warning: { bg: '#FFFBEB', border: '#D97706', text: '#92400E', icon: 'fa-exclamation-triangle' },
        light: { bg: '#F8FAFC', border: '#64748B', text: '#1E293B', icon: 'fa-bell' }
    }[type] || { bg: '#F8FAFC', border: '#64748B', text: '#1E293B', icon: 'fa-bell' };

    return (
        <div 
            className="animate__animated animate__fadeInDown"
            style={{
                backgroundColor: theme.bg,
                borderLeft: `4px solid ${theme.border}`,
                borderRadius: '8px',
                padding: '12px 16px',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                transition: 'all 0.3s ease'
            }}
        >
            <div className="d-flex align-items-center">
                <i className={`fa ${theme.icon} mr-3`} style={{ color: theme.border, fontSize: '18px' }}></i>
                <span style={{ 
                    color: theme.text, 
                    fontSize: '14px', 
                    fontWeight: '500',
                    lineHeight: '1.4' 
                }}>
                    {message}
                </span>
            </div>

            {closable && (
                <button 
                    type="button" 
                    onClick={() => setShow(false)}
                    style={{
                        background: 'transparent',
                        border: 'none',
                        color: theme.text,
                        opacity: 0.5,
                        cursor: 'pointer',
                        padding: '4px',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.opacity = 1}
                    onMouseOut={(e) => e.currentTarget.style.opacity = 0.5}
                >
                    <i className="fa fa-times" style={{ fontSize: '14px' }}></i>
                </button>
            )}
        </div>
    );
};

export default Notification;